import { Injectable } from '@angular/core';

import { NavigationService } from '@core/services/navigation/navigation.service';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class RestrictionsCommand extends BaseProductCommand {
  readonly type = 'restrictions';
  readonly title = 'Ограничения';
  readonly icon = 'hand-back';
  readonly productType = [
    ProductTypes.ACCOUNT,
    ProductTypes.CARD,
    ProductTypes.DEPOSIT,
    ProductTypes.SAVE_ACCOUNT,
    ProductTypes.METAL_ACCOUNT
  ];

  // Обновлено согласно задаче #26325: единая настройка для всего функционала скрытия счетов
  readonly settingsNames = ['REQUEST/PRODUCT_RESTRICTION'];
  readonly subCommands = ['hideAccount', 'softHideAccount', 'unblockAccount', 'unblockCard'];

  readonly isInfoAction = false;
  readonly order = 6; // После "Доп карта" (порядок 5)

  constructor(
    private readonly navigationService: NavigationService,
    protected readonly commandAvailabilityService: CommandAvailabilityService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    // Переход на страницу ограничений с передачей id продукта
    await this.navigationService.push(`product/${context.data.id}/restrictions`, { state: { product: context.data } });
  }
}
